import { Navigate, Outlet, useLocation } from 'react-router'

import { paths } from '@/app/router/paths'
import { FullPageLoader } from '@/components/common/FullPageLoader'
import { env } from '@/config/env'
import { useAuthStore } from '@/features/auth/store/auth.store'

type LocationState = { from?: { pathname: string } }

/**
 * Keeps signed-in users out of the login screen, and owns the post-login
 * redirect: it reacts to the account the moment it lands, so no other
 * component should also navigate on sign-in.
 */
export function GuestRoute() {
  const location = useLocation()
  const isHydrated = useAuthStore((state) => state.isHydrated)
  const hasEntraAccount = useAuthStore((state) => state.hasEntraAccount)

  if (!isHydrated) return <FullPageLoader />

  // Auth disabled: there is nothing to sign in to, so /login is a dead end.
  if (!env.requireAuth) return <Navigate to={paths.projects.pipeline} replace />

  if (hasEntraAccount) {
    // `from` is stamped by ProtectedRoute when it bounced an unauthenticated user.
    const from = (location.state as LocationState | null)?.from?.pathname
    return <Navigate to={from ?? paths.projects.pipeline} replace />
  }

  return <Outlet />
}
